import { call, put, takeEvery } from 'redux-saga/effects';
import AfCoreRequest from '../../../../bootstrap/redux-data/AfCoreRequest';
import RequestMiddlewarePipeline from '../../../../../boilerplate/redux/RequestMiddlewarePipeline';
import {
	addConfirmLotteryRegistrationEntries,
	CONFIRM_LOTTERY_REGISTRATION_FETCH_ENTRIES, setConfirmLotteryRegistrationErrors,
} from './confirmLotteryRegistrationActions';


/**
 * Fetch entry list
 */
function* confirmLotteryRegistration(action: any) {
	const afCoreRequest = new AfCoreRequest(action.queryKey);

	try {
		const response = yield call((): Promise<RequestMiddlewarePipeline> => {
			return afCoreRequest.postRequest({
				url: '/api/public/v1/lottery/verify-subscription',
				body: action.params,
			} as IRequestObject);
		});

		yield put(addConfirmLotteryRegistrationEntries(
			action.queryKey,
			[],
			response.getMetaData(),
			action.options,
		));
	} catch (e) {
		yield put(setConfirmLotteryRegistrationErrors(action.queryKey, e));
	}
}

export function* confirmLotteryRegistrationSaga() {
	yield takeEvery(CONFIRM_LOTTERY_REGISTRATION_FETCH_ENTRIES, confirmLotteryRegistration);
}
